import React, { Component } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const GELECEK_RANDEVULAR_API = 'https://randevuapi.uzmdrzelihaaksoy.com/gelecek-randevular';
const GECMIS_RANDEVULAR_API = 'https://randevuapi.uzmdrzelihaaksoy.com/gecmis-randevular';

const DAY_LABELS = ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pz'];
const DAY_NAMES_FULL = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
const MONTH_NAMES = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const DURUM_RENK = {
  planlandi: 'bg-sky-500',
  iptal: 'bg-red-500',
  tamamlandi: 'bg-emerald-500'
};

function toISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function buildCalendarWeeks(monthDate) {
  const year = monthDate.getFullYear();
  const month = monthDate.getMonth();
  const firstOfMonth = new Date(year, month, 1);
  const startOffset = (firstOfMonth.getDay() + 6) % 7; // Pazartesi = 0
  const gridStart = new Date(year, month, 1 - startOffset);

  const days = [];
  for (let i = 0; i < 42; i++) {
    const date = new Date(gridStart);
    date.setDate(gridStart.getDate() + i);
    days.push({ date, outside: date.getMonth() !== month });
  }

  const weeks = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days.slice(i, i + 7));
  }
  while (weeks.length > 0 && weeks[weeks.length - 1].every(d => d.outside)) {
    weeks.pop();
  }
  return weeks;
}

class Takvim extends Component {

  constructor(props) {
    super(props);

    this.auth = localStorage.getItem('auth');
    const today = startOfDay(new Date());

    this.state = {
      loading: true,
      error: '',
      currentMonth: new Date(today.getFullYear(), today.getMonth(), 1),
      selectedDate: today,
      randevularByDate: {}
    };

    this.handleSSE = this.handleSSE.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.goToToday = this.goToToday.bind(this);
    this.goToPrevMonth = this.goToPrevMonth.bind(this);
    this.goToNextMonth = this.goToNextMonth.bind(this);
    this.selectDate = this.selectDate.bind(this);
  }

  componentDidMount() {
    this.fetchRandevular();
    window.addEventListener('sse', this.handleSSE);
  }

  componentWillUnmount() {
    window.removeEventListener('sse', this.handleSSE);
  }

  handleBack() {
    this.props.history.goBack();
  }

  handleSSE(event) {
    const ilgiliTipler = ['randevu-olusturuldu', 'randevu-guncellendi', 'randevu-silindi'];
    if (event.detail && ilgiliTipler.includes(event.detail.type)) {
      this.fetchRandevular();
    }
  }

  fetchRandevular() {
    const headers = { Authorization: 'Basic ' + this.auth };

    Promise.all([
      axios.get(GELECEK_RANDEVULAR_API, { headers }),
      axios.get(GECMIS_RANDEVULAR_API, { headers })
    ])
      .then(([gelecekRes, gecmisRes]) => {
        const hepsi = [
          ...gelecekRes.data.map(r => ({ ...r, durum: r.durum || 'planlandi' })),
          ...gecmisRes.data
        ].filter(randevu => randevu.durum !== 'iptal');

        const randevularByDate = hepsi.reduce((acc, randevu) => {
          if (!acc[randevu.tarih]) acc[randevu.tarih] = [];
          acc[randevu.tarih].push(randevu);
          return acc;
        }, {});

        Object.keys(randevularByDate).forEach(tarih => {
          randevularByDate[tarih].sort((a, b) => a.saat.localeCompare(b.saat));
        });

        this.setState({ randevularByDate, loading: false, error: '' });
      })
      .catch(() => {
        this.setState({ loading: false, error: 'Randevular alınamadı.' });
      });
  }

  goToToday() {
    const today = startOfDay(new Date());
    this.setState({ currentMonth: new Date(today.getFullYear(), today.getMonth(), 1), selectedDate: today });
  }

  goToPrevMonth() {
    this.setState(prev => ({
      currentMonth: new Date(prev.currentMonth.getFullYear(), prev.currentMonth.getMonth() - 1, 1)
    }));
  }

  goToNextMonth() {
    this.setState(prev => ({
      currentMonth: new Date(prev.currentMonth.getFullYear(), prev.currentMonth.getMonth() + 1, 1)
    }));
  }

  selectDate(date) {
    this.setState({ selectedDate: date });
  }

  render() {
    const { loading, error, currentMonth, selectedDate, randevularByDate } = this.state;
    const today = startOfDay(new Date());
    const weeks = buildCalendarWeeks(currentMonth).map(week =>
      week.map(({ date, outside }) => ({
        date,
        outside,
        today: toISODate(date) === toISODate(today),
        selected: selectedDate && toISODate(date) === toISODate(selectedDate),
        disabled: date.getDay() === 0
      }))
    );
    const selectedISO = toISODate(selectedDate);
    const selectedRandevular = randevularByDate[selectedISO] || [];

    return (
      <div className="max-w-4xl mx-auto space-y-7">
        <header className="space-y-3">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-slate-900">Takvim</h1>
          <button
            type="button" onClick={this.handleBack}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"></path></svg>
            Geri
          </button>
        </header>

        {loading && <p className="text-sm text-slate-500">Yükleniyor...</p>}
        {error && <p className="text-sm text-red-500">{error}</p>}

        {!loading && !error && (
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1">
              <div className="border border-slate-200 rounded-xl bg-white p-3">
                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-2 px-1 py-1">
                    <button
                      type="button" aria-label="Önceki ay" onClick={this.goToPrevMonth}
                      className="inline-flex items-center justify-center rounded-md h-7 w-7 border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"></path></svg>
                    </button>
                    <span className="flex-1 text-sm font-semibold text-slate-800 text-center">
                      {MONTH_NAMES[currentMonth.getMonth()]} {currentMonth.getFullYear()}
                    </span>
                    <button
                      type="button" aria-label="Sonraki ay" onClick={this.goToNextMonth}
                      className="inline-flex items-center justify-center rounded-md h-7 w-7 border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"></path></svg>
                    </button>
                    <button
                      type="button" onClick={this.goToToday}
                      className="ml-2 px-2.5 h-7 inline-flex items-center rounded-md text-xs font-medium text-slate-600 border border-slate-200 bg-white hover:bg-slate-50 transition-colors"
                    >
                      Bugün
                    </button>
                  </div>

                  <table className="w-full border-collapse table-fixed">
                    <thead>
                      <tr className="flex">
                        {DAY_LABELS.map((label, i) => (
                          <th key={label} aria-label={DAY_NAMES_FULL[i]} scope="col" className="flex-1 text-center text-[0.75rem] font-medium text-slate-400 pb-1">{label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="flex flex-col gap-1">
                      {weeks.map((week, wi) => (
                        <tr key={wi} className="flex">
                          {week.map((day) => {
                            const iso = toISODate(day.date);
                            const gunRandevulari = randevularByDate[iso] || [];

                            const dayClasses = [
                              'calendar-day w-12 h-12 flex flex-col items-center justify-center rounded-md text-base font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-sky-500'
                            ];
                            if (day.disabled) {
                              dayClasses.push('text-slate-300 opacity-40 cursor-not-allowed');
                            } else {
                              dayClasses.push('cursor-pointer');
                              if (day.outside) dayClasses.push('text-slate-300');
                            }
                            if (day.selected) {
                              dayClasses.push('bg-sky-600 text-white font-semibold');
                            } else if (day.today) {
                              dayClasses.push('bg-slate-100 font-semibold text-slate-900');
                              if (!day.disabled) dayClasses.push('hover:bg-slate-200');
                            } else if (!day.disabled) {
                              dayClasses.push('hover:bg-slate-100');
                            }

                            return (
                              <td key={iso} className="flex-1 h-12 flex items-center justify-center p-0 relative">
                                <button
                                  type="button"
                                  data-date={iso}
                                  disabled={day.disabled}
                                  onClick={() => this.selectDate(day.date)}
                                  className={dayClasses.join(' ')}
                                >
                                  {day.date.getDate()}
                                  {gunRandevulari.length > 0 && (
                                    <span className="mt-0.5 w-1.5 h-1.5 rounded-full bg-red-500"></span>
                                  )}
                                </button>
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="md:w-72 flex flex-col gap-3">
              <p className="border border-slate-100 rounded-xl px-4 py-3.5 shadow-sm hover:shadow-md transition-shadow bg-amber-50 flex items-center gap-2.5 capitalize">
                {selectedDate.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' })}
              </p>

              {selectedRandevular.length === 0 && (
                <p className="text-sm text-slate-500">Bu tarihte randevu yok.</p>
              )}

              {selectedRandevular.map(randevu => (
                <NavLink
                  key={randevu.uuid}
                  to={`/randevu/${randevu.uuid}`}
                  className="border border-slate-100 rounded-xl px-4 py-3.5 shadow-sm hover:shadow-md transition-shadow bg-white flex items-center gap-2.5"
                >
                  <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${DURUM_RENK[randevu.durum] || 'bg-slate-400'}`}></span>
                  <div>
                    <p className="text-sm font-semibold text-slate-900">{randevu.saat.split('-')[0]}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{randevu.hasta_adi}</p>
                  </div>
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Takvim
